var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgView({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 16,
    viewBox: "0 0 22 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.812505 8.09738C0.729165 7.87287 0.729165 7.6259 0.812505 7.40138C1.62421 5.43324 3.00202 3.75042 4.77128 2.56628C6.54053 1.38214 8.62155 0.75 10.7505 0.75C12.8795 0.75 14.9605 1.38214 16.7297 2.56628C18.499 3.75042 19.8768 5.43324 20.6885 7.40138C20.7718 7.6259 20.7718 7.87287 20.6885 8.09738C19.8768 10.0655 18.499 11.7483 16.7297 12.9325C14.9605 14.1166 12.8795 14.7488 10.7505 14.7488C8.62155 14.7488 6.54053 14.1166 4.77128 12.9325C3.00202 11.7483 1.62421 10.0655 0.812505 8.09738Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7505 10.7494C12.4074 10.7494 13.7505 9.40624 13.7505 7.74938C13.7505 6.09253 12.4074 4.74938 10.7505 4.74938C9.09365 4.74938 7.75051 6.09253 7.75051 7.74938C7.75051 9.40624 9.09365 10.7494 10.7505 10.7494Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgView);
export default __webpack_public_path__ + "static/media/View.d9719e11a1db69d6e853a901be7b9802.svg";
export { ForwardRef as ReactComponent };